import { store } from '@redux/store';
import modalService from 'layout/services/modalService';
import DetailsAnchor from './detailsAnchor';
import { closeModalSvg, thanksContentSvg } from '../constants/svgIcons';

export default class ThankScreenTour {
  constructor() {
    const state = store.getState();
    const modalInformation = state?.uiState?.modalInformation;
    const listingInformation = modalInformation?.listingInformation;
    this.url = modalInformation?.url;
    this.builderName = listingInformation?.brandName ?? 'the builder';
    this.closeAttribute = '[data-close]';
    this.moreDetailsAnchor = new DetailsAnchor();
    this.moreDetailsAnchor.setUrl(this.url);
    this.moreDetailsAnchor.setListingId(listingInformation.id);
    this.moreDetailsAnchor.setListingType(listingInformation.type);
  }

  bindEvents() {
    const closeElements = document.querySelectorAll(this.closeAttribute);
    closeElements.forEach((element) => element.addEventListener('click', ThankScreenTour.closeModal));
    this.moreDetailsAnchor.bindEvents();
  }

  static closeModal() {
    modalService.clearHtml();
  }

  getHtml() {
    return `
    <div class="lead-form form--thanks">
      <button class="modal__close" data-close>
        ${closeModalSvg}          
      </button>
      <div class="thanks__content">
        ${thanksContentSvg}
        <p class="thanks__title">Thank You!</p>
        <p class="thanks__subtitle">Your request has been sent to ${this.builderName}.</p>
        <p>They will be in touch with you soon with more information!</p>
      </div>
      <div class="form__button-bar">
        <button class="btn btn--white btn--48-lg" data-close>
          Return to Search
        </button>
        ${this.moreDetailsAnchor.getHtml()}
      </div>
    </div>`;
  }
}
